var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadPicture(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4583 0 0 13.4583 0 30C0 46.5417 13.4583 60 30 60C46.5417 60 60 46.5417 60 30C60 13.4583 46.5417 0 30 0Z",
    fill: "#2A2B79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 2.49994C45.1636 2.49994 57.5001 14.8364 57.5001 30C57.5001 36.0361 55.5222 41.606 52.2125 46.1462C51.9234 45.9581 51.6377 45.7865 51.3477 45.6371C46.338 43.0652 38.5669 39.9999 30 39.9999C21.4332 39.9999 13.6621 43.0652 8.65117 45.6384C8.36207 45.7872 8.07672 45.9583 7.78774 46.1462C4.47801 41.6058 2.5 36.0361 2.5 30C2.5 14.8364 14.8364 2.49994 30 2.49994Z",
    fill: "#F8F9FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9994 57.5C21.7774 57.5 14.4069 53.8546 9.36328 48.1165C9.50707 48.0294 9.65203 47.9347 9.7943 47.8614C14.5587 45.4151 21.9318 42.5 29.9994 42.5C38.0671 42.5 45.44 45.4151 50.2032 47.8602C50.3462 47.934 50.4915 48.0288 50.6357 48.1164C45.5919 53.8543 38.2214 57.5 29.9994 57.5Z",
    fill: "#2A2B79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 37.5C38.2843 37.5 45 30.7843 45 22.5C45 14.2157 38.2843 7.5 30 7.5C21.7157 7.5 15 14.2157 15 22.5C15 30.7843 21.7157 37.5 30 37.5Z",
    fill: "#2A2B79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M41.3357 55.0301C44.9061 53.3986 48.0736 51.0319 50.6364 48.1164C50.4923 48.0288 50.347 47.934 50.204 47.8602C45.4408 45.4151 38.0677 42.5 30.0002 42.5C29.6139 42.5 29.2383 42.5368 28.8555 42.5497L41.3357 55.0301Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 35C36.9036 35 42.5001 29.4036 42.5001 22.5C42.5001 15.5964 36.9036 9.99994 30.0001 9.99994C23.0965 9.99994 17.5 15.5964 17.5 22.5C17.5 29.4036 23.0965 35 30.0001 35Z",
    fill: "#2A2B79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.7024 11.9841C37.1917 13.3212 37.5011 14.7456 37.5011 16.2502C37.5011 23.1426 31.8937 28.7502 25.0011 28.7502C22.5311 28.7502 20.2408 28.0074 18.2998 26.7663C20.0525 31.5546 24.6129 35.0002 30.001 35.0002C36.8935 35.0002 42.501 29.3925 42.501 22.5002C42.5011 18.0775 40.1778 14.2067 36.7024 11.9841Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4583 0 0 13.4583 0 30C0 46.5417 13.4583 60 30 60C46.5417 60 60 46.5417 60 30C60 13.4583 46.5417 0 30 0Z",
    fill: "url(#paint0_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.75 26.4592H35.25C36.0784 26.4592 36.75 27.1308 36.75 27.9592V33.9592C36.75 34.7877 36.0784 35.4592 35.25 35.4592H24.75C23.9216 35.4592 23.25 34.7877 23.25 33.9592V27.9592C23.25 27.1308 23.9216 26.4592 24.75 26.4592ZM30 33.9592C31.6569 33.9592 33 32.6161 33 30.9592C33 29.3024 31.6569 27.9592 30 27.9592C28.3431 27.9592 27 29.3024 27 30.9592C27 32.6161 28.3431 33.9592 30 33.9592Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.5 24.2092H28.5C28.0858 24.2092 27.75 24.545 27.75 24.9592C27.75 25.3734 28.0858 25.7092 28.5 25.7092H31.5C31.9142 25.7092 32.25 25.3734 32.25 24.9592C32.25 24.545 31.9142 24.2092 31.5 24.2092Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30 32.4592C30.8284 32.4592 31.5 31.7877 31.5 30.9592C31.5 30.1308 30.8284 29.4592 30 29.4592C29.1716 29.4592 28.5 30.1308 28.5 30.9592C28.5 31.7877 29.1716 32.4592 30 32.4592Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.812,
    y1: 17.326,
    x2: 57.1884,
    y2: 42.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPicture);
export default __webpack_public_path__ + "static/media/uploadPicture.3832a4e8ce5d7c202322bd835d722fc6.svg";
export { ForwardRef as ReactComponent };